import { DashboardExportCtrl } from '../dashboard.export/dashboard.export.controller';

routesConfig.$inject = ['$stateProvider'];

export function routesConfig($stateProvider) {
  $stateProvider
    .state('dashboard', {
      url: '/dashboard',
      template: require('../dashboard/dashboard.html'),
      controller: [
        '$state',
        ($state) => {
          if ($state.current.name === 'dashboard') {
            $state.go('dashboard.main');
          }
        },
      ],
    })
    .state('dashboard.main', {
      url: '/main',
      template: require('../dashboard.main/dashboard.main.html'),
      controller: 'dashboardMainCtrl',
      controllerAs: 'vm',
    })
    .state('dashboard.leadWorking', {
      url: '/lead-working',
      template: require('../dashboard.lead.working/dashboard.lead.working.html'),
      controller: 'dashboardLeadWorkingCtrl',
      controllerAs: 'vm',
    })
    .state('dashboard.overview', {
      url: '/project-overview',
      template: require('../dashboard.project.overview/project.overview.html'),
    })
    .state('dashboard.stock', {
      url: '/stock',
      template: require('../dashboard.stock/dashboard.stock.html'),
      controller: 'dashboardStockCtrl',
      controllerAs: 'vm',
    })
    .state('dashboard.projectalltime', {
      url: '/project-alltime',
      template: require('../dashboard.project.alltime/dashboard.project.alltime.html'),
      controller: 'dashboardProjectAlltimeCtrl',
      controllerAs: 'vm',
    })
    .state('dashboard.employeeSales', {
      url: '/employee-sales',
      template: require('../dashboard.employee.sales/dashboard.employee.sales.html'),
      controller: 'dashboardEmployeeSalesCtrl',
      controllerAs: 'vm',
    })
    .state('dashboard.interval', {
      url: '/interval',
      template: require('../dashboard.interval/dashboard.dashboard.html'),
    })
    .state('dashboard.export', {
      url: '/export',
      template: require('../dashboard.export/dashboard.export.html'),
      controller: DashboardExportCtrl,
      controllerAs: 'vm',
    });
}
